module.exports = __webpack_public_path__ + "images/emoji/custard.4af11b8fa98e6b2c4e1d.png";